export default __webpack_public_path__ + "static/media/ilona_korinets.c4a92604.png";